import React from 'react';

import { InvalidBuyerChat } from '../types';

interface InvalidChatsSectionProps {
  invalidChats: InvalidBuyerChat[];
}

export const InvalidChatsSection: React.FC<InvalidChatsSectionProps> = ({
  invalidChats,
}) => {
  if (invalidChats.length === 0) return null;

  return (
    <div className="mt-4 p-4 bg-warning-50 border border-warning-200 rounded-lg">
      <h6 className="text-sm font-medium text-warning-800 mb-2">
        Invalid Chats
      </h6>
      <p className="text-sm text-warning-700 mb-2">
        The following chats are no longer valid because their supplier has been
        removed:
      </p>
      <ul className="list-disc list-inside text-sm text-warning-700">
        {invalidChats.map((chat) => (
          <li key={chat.chatId}>{chat.chatName || 'Unnamed Chat'}</li>
        ))}
      </ul>
    </div>
  );
};
